import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Material-UI Components
import {
  Box,
  Drawer,
  List,
  ListItem,
  useTheme,
  Typography,
  IconButton,
  useMediaQuery,
} from "@mui/material";

// Material-UI Icons
import MenuIcon from "@mui/icons-material/Menu";

// Images
import MSTC_LOGO from "../images/mstc.png";

const routes = [
  { name: "Home", path: "/" },
  { name: "Events", path: "/events" },
  { name: "Winners", path: "/winners" },
  { name: "Members", path: "/members" },
  { name: "Contact Us", path: "/contact-us" },
];

function NavBar() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  return (
    <Box
      sx={{
        py: 1,
        px: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        bgcolor: "#023047",
        color: "white",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => navigate("/")}
      >
        <img src={MSTC_LOGO} alt="MSTC_LOGO" style={{ width: 50 }} />
        <Typography variant="h6" sx={{ mx: 2 }}>
          {isSmallScreen ? "MSTC" : "Microsoft Student Technical Club, DA-IICT"}
        </Typography>
      </Box>

      {/* Hamburger Menu for Small Screens */}
      <Box
        sx={{
          display: { xs: "block", sm: "block", md: "none" }, // Show on small screens only
        }}
      >
        <IconButton onClick={toggleDrawer(true)}>
          <MenuIcon sx={{ color: "white" }} />
        </IconButton>
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          onClose={toggleDrawer(false)}
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
          >
            <List>
              {routes.map((route) => (
                <ListItem
                  button={"true"}
                  key={route.name}
                  sx={{
                    cursor: "pointer",
                    "&:hover": { bgcolor: "transparent" },
                  }}
                  onClick={() => {
                    navigate(route.path);
                    console.log("first");
                  }}
                >
                  <Typography
                    fontWeight="bold"
                    sx={{
                      p: 1,
                      width: "100%",
                      color: "#023047",
                      "&:hover": { bgcolor: "#03045e", color: "white" },
                      border: "1px solid grey",
                      borderRadius: "6px",
                    }}
                  >
                    {route.name}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Box>
        </Drawer>
      </Box>

      {/* Navigation Links for Larger Screens */}
      <Box
        sx={{
          display: { xs: "none", sm: "none", md: "flex" }, // Hide on small screens
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        {routes.map((route) => (
          <Typography
            onClick={() => navigate(route.path)}
            key={route.name}
            fontWeight="bold"
            sx={{
              color: "white",
              fontSize: { sm: "1rem" },
              textAlign: "center",
              px: 1,
              "&:hover": {
                cursor: "pointer",
                textDecoration: "underline",
              },
            }}
          >
            {route.name}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}

export default NavBar;
